export default defineNuxtPlugin({
  name: 'kameleoon',
  async setup() {
    return {
      provide: {
        kameleoon: null,
      },
    }
  },
})
